export default function render({ gap_x, gap_y, col_min_width }) {
  return {
    display: "inline-grid",
    "grid-gap": gap_y + "px " + gap_x + "px",
    "grid-template-columns": `repeat(auto-fill, minmax(${col_min_width + "px"}, 1fr))`,
    "grid-auto-rows": "1fr"
  };
}
